import { PlannerMultiple } from 'mixs/orders/planner';

class TodaysIndex extends PlannerMultiple {
}

riot.mixin('todays.index', TodaysIndex as riot.TagMixin)
